module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Récapitulatif","titlePartyName":"Nom de la partie","titlePlatform":"Destination","titleTeams":"Equipes","titleDates":"Dates","from":"Du","to":"au","team":"Une équipe | {count} équipes"},"en":{"title":"Summary","titlePartyName":"Game name","titlePlatform":"Destination","titleTeams":"Teams","titleDates":"Dates","from":"From","to":"To","team":"One team | {count} teams"}}')
  delete Component.options._Ctor
}
